import React, { ElementType } from "react";
import { Flex, Text, Icon } from "@chakra-ui/react";
import { Link } from "react-router-dom";
interface BoxProps {
  value: number | string;
  title: string;
  bg: string;
  color: string;
  icon: ElementType;
  link?: string;
  onClick?: () => void;
  border: string;
  footer?: string;
}

export function Box({
  value,
  title,
  bg,
  color,
  icon,
  link,
  onClick,
  border,
  footer,
}: BoxProps) {
  return (
    <>
      {link ? (
        <Link to={link}>
          <Flex
            borderRadius=".35rem"
            bg="white"
            fontSize="2.2rem"
            margin="0 0 10px 0 "
            whiteSpace="nowrap"
            mb="1rem"
            minH="70"
            p=".50rem"
            w="100%"
            shadow="md"
            borderTop={`3px solid ${border}`}
            borderColor={border}
          >
            <Flex
              borderRadius="50%"
              alignItems="center"
              fontSize="1.875rem"
              justify="center"
              textAlign="center"
              w="65px"
              h="65px"
              bg={bg}
            >
              <Icon as={icon} color={color} />
            </Flex>
            <Flex flexDir="column" justify="space-around" flex="1" p="0 10px">
              <Text
                display="block"
                overflow="hidden"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
                fontSize="16px"
              >
                {title}
              </Text>
              <Text
                display="block"
                fontSize="16px"
                mt=".25rem"
                fontWeight="bold"
              >
                {value}
              </Text>
            </Flex>
            {footer && (
              <Text display="block" fontSize="16px" mt="auto">
                {" "}
                {footer}
              </Text>
            )}
          </Flex>
        </Link>
      ) : (
        <Flex
          onClick={onClick}
          cursor={onClick ? "pointer" : "unset"}
          borderRadius=".25rem"
          bg="white"
          fontSize="2.2rem"
          margin="0 0 10px 0 "
          whiteSpace="nowrap"
          mb="1rem"
          minH="80px"
          p=".5rem"
          w="100%"
          shadow="md"
          borderTop={`3px solid ${border}`}
          alignItems="center"
          borderColor={border}
        >
          <Flex
            borderRadius="50%"
            alignItems="center"
            fontSize="1.875rem"
            justify="center"
            textAlign="center"
            w="65px"
            h="65px"
            minW="65px"
            bg={bg}
          >
            <Icon as={icon} color={color} />
          </Flex>
          <Flex flexDir="column" justify="space-around" flex="1" p="0 10px">
            <Text
              display="block"
              overflow="hidden"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
              fontSize="16px"
            >
              {title}
            </Text>
            <Text display="block" fontSize="16px" mt=".25rem" fontWeight="bold">
              {value}
            </Text>
          </Flex>
          {footer && (
            <Text display="block" fontSize="16px" mt={"auto"}>
              {" "}
              {footer}
            </Text>
          )}
        </Flex>
      )}
    </>
  );
}
